<template>
  <div class="bannerItems">
    <div class="b-box">
      <img src="../../static/images/blockChain/chain.png">
      <div class="text-box">
        <h1>打破信息孤岛，全流程追踪，分布式存储，不可篡改</h1>
        <p>保全链开放平台是由君子签联合仲裁委、版权机构、公证处、互联网法院等打造的联盟链，实现数据从生成、存储、传输到最终提交的整个环节真实可信， 司法权威节点可见，具有法律效力。</p>
      </div>
    </div>
    <div class="block-wrap">
      <div class="item">
        <img src="../../static/images/blockChain/height.png">
        <div>
          <p>{{blockHeight}}</p>
          <span>区块链高度</span>
        </div>
      </div>
      <div class="item">
        <img src="../../static/images/blockChain/user.png" style="width: 74px;">
        <div>
          <p v-html="blockUser"></p>
          <span>存证用户量</span>
        </div>
      </div>
      <div class="item">
        <img src="../../static/images/blockChain/data.png" style="width: 74px;">
        <div>
          <p v-html="blockData"></p>
          <span>存证数据量</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import BlockChain from '../../assets/js/http-serve/blockChain'
    export default {
        name: "banner",
        data() {
            return {
                blockHeight: null,
                blockUser: null,
                blockData: null
            }
        },
        created() {
            this.getBlock()
        },
        methods: {
            getBlock() {
                // HttpApi.
                BlockChain.presCntAndMnt().then(res => {
                    if (res.data.success) {
                        this.blockHeight = res.data.data.chainInfo.currentBlock.number
                        this.blockUser = res.data.data.preservation_users
                        this.blockData = res.data.data.preservation_number
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
  .bannerItems {
    width: 100%;
    height: 100%;
    background: url('/images/blockChain/banner.png') no-repeat center center;
    background-size: cover;
    position: relative;

    .b-box{
      width: 1200px;
      height: 100%;
      /*display: block;*/
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      img{
        width: 400px;
        height: auto;
        display: block;
        margin: 0 68px 0 71px;
      }
      .text-box{
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 200;
        line-height: 50px;
        color: #FFFFFF;
        h1{
          font-family: HuXiaoBo-NanShen;
          font-size: 26px;
        }
        p {
          width: 90%;
          text-align: justify;
        }
      }
    }

    .block-wrap{
      position:absolute;
      width: 1200px;
      margin-left: -600px;
      left: 50%;
      bottom:-74px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .item {
      width: 380px;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.16);
      border-radius: 10px;

      img {
        width: 105px;
        height: auto;
      }
      div {
        margin-left: 20px;
        color: rgba(236, 28, 28, 1);

        p {
          font-size: 28px;
          font-weight: bold;
          /deep/ span{
            color: rgba(236, 28, 28, 1) !important;
          }
        }
        span {
          font-size: 14px;
          font-weight: 300;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/blockChain/banner.vue